// eslint-disable-next-line import/prefer-default-export
export const ScheduleSource = Object.freeze({
    WorkplanManager: 0,
    ExcelFile: 1,
});
